export const BLOCK_VARIABLE = 'variable';
export const BLOCK_SEARCH = 'variable-search';
